import { BLOCKS, INLINES } from '@contentful/rich-text-types'

import type { Document as RichTextDocument } from '@contentful/rich-text-types'

export interface FAQ {
  title: string
  description: RichTextDocument
}

export const faqs: FAQ[] = [
  {
    title: `How can I estimate my MTUs?`,
    description: {
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: `To get an idea of your MTU count, add your monthly active users to the number of anonymous visitors you get per month. Some tools also call this metric "Monthly Unique Visitors."`,
              nodeType: `text`,
            },
          ],
          nodeType: BLOCKS.PARAGRAPH,
        },
      ],
      data: {},
      nodeType: BLOCKS.DOCUMENT,
    },
  },
  {
    title: `Is there a free trial of the paid plans?`,
    description: {
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value: `Not for Customer Data Platform (CDP) plans. However, there is a 14-day free trial for the Connections Team plan. Learn more about `,
                  nodeType: `text`,
                },
                {
                  data: {
                    uri: `/pricing/connections/`,
                  },
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: `Connections plans`,
                      nodeType: `text`,
                    },
                  ],
                  nodeType: INLINES.HYPERLINK,
                },
                {
                  data: {},
                  marks: [],
                  value: `.`,
                  nodeType: `text`,
                },
              ],
              nodeType: BLOCKS.PARAGRAPH,
            },
          ],
          nodeType: BLOCKS.PARAGRAPH,
        },
      ],
      data: {},
      nodeType: BLOCKS.DOCUMENT,
    },
  },
  {
    title: `Can I connect sources for real-time events and reverse ETL from my warehouse?`,
    description: {
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: `Yes! Segment Customer Data Platform (CDP) enables your team to start anywhere and activate everywhere, including your data warehouse and 450+ sources. If you are interested in a reverse ETL only plan, `,
              nodeType: `text`,
            },
            {
              data: {
                uri: `/demo/`,
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: `contact us`,
                  nodeType: `text`,
                },
              ],
              nodeType: INLINES.HYPERLINK,
            },
            {
              data: {},
              marks: [],
              value: `.`,
              nodeType: `text`,
            },
          ],
          nodeType: BLOCKS.PARAGRAPH,
        },
      ],
      data: {},
      nodeType: BLOCKS.DOCUMENT,
    },
  },
  {
    title: `Does Segment handle billing for my Sources or Destinations services?`,
    description: {
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: `No, you’re responsible for accounts that you register with Sources, Integrations, and Warehouse providers, whether they are paid or free.`,
              nodeType: `text`,
            },
          ],
          nodeType: BLOCKS.PARAGRAPH,
        },
      ],
      data: {},
      nodeType: BLOCKS.DOCUMENT,
    },
  },
  {
    title: `Do I need to have a data warehouse to use warehouses?`,
    description: {
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: `Segment connects to your existing data warehouse and pipes in data collected from your Sources. You don't have to worry about the ETL or maintaining the data pipeline.`,
              nodeType: `text`,
            },
          ],
          nodeType: BLOCKS.PARAGRAPH,
        },
      ],
      data: {},
      nodeType: BLOCKS.DOCUMENT,
    },
  },
  {
    title: `How can I buy Protocols?`,
    description: {
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: `Protocols is included in each Customer Data Platform (CDP) plan.`,
              nodeType: `text`,
            },
          ],
          nodeType: BLOCKS.PARAGRAPH,
        },
      ],
      data: {},
      nodeType: BLOCKS.DOCUMENT,
    },
  },
]
